export default {
  awards: [
    {
      awarder: 'F1® Connectivity Innovation Prize',
      name: 'Virtual Fan Experience Solution Winners',
      year: 2016
    },
    {
      awarder: 'F1® Connectivity Innovation Prize',
      name: 'Virtual Operations Solution Winners',
      year: 2016
    },
    {
      awarder: 'EIBA',
      name: 'Growth and Innovation Winners',
      year: 2016
    },
    {
      awarder: 'BT Infinity Lab',
      name: 'Connected Cities Finalist',
      year: 2016
    },
    {
      awarder: 'PWC Private Business Awards',
      name: 'Entrepreneur of the Year Finalist',
      year: 2015
    },
    {
      awarder: 'EIBA',
      name: 'Young Business of the Year Winners',
      year: 2014
    },
    {
      awarder: 'Royal Air Force Benevolent Fund Awards',
      name: 'Most Innovative Support Winners',
      year: 2014
    },
    {
      awarder: 'Shropshire Business Awards',
      name: 'Best New Business Winners',
      year: 2013
    },
    {
      awarder: 'Shropshire Business Awards',
      name: 'Technology, Enterprise and Innovation Winners',
      year: 2012
    }
  ],
  careerReasons: [
    {
      text: 'A working environment where we take our culture and work ethic seriously.'
    },
    {
      text: 'A group of talented, versatile and passionate people.'
    },
    {
      text: 'The chance to work on the most top-secret and innovative projects in the world.'
    },
    {
      text: 'A climate where you will be expected to help us become better. Every day.'
    }
  ],
  clients: [
    {
      logo: 'abellio.svg'
    },
    {
      logo: 'bae.svg'
    },
    {
      logo: 'ce.svg'
    },
    {
      logo: 'cisco.svg'
    },
    {
      logo: 'crt.svg'
    },
    {
      logo: 'dakro.svg'
    },
    {
      logo: 'eh.svg'
    },
    {
      logo: 'energ.svg'
    },
    {
      logo: 'filtermist.svg'
    },
    {
      logo: 'iuk.svg'
    },
    {
      logo: 'maa.svg'
    },
    {
      logo: 'prt.svg'
    },
    {
      logo: 'rafbf.svg'
    },
    {
      logo: 'sc.svg'
    },
    {
      logo: 'schneider.svg'
    },
    {
      logo: 'telent.svg'
    },
    {
      logo: 'redbull.svg'
    },
    {
      logo: 'twc.svg'
    }
  ],
  f42Clients: [
    {
      logo: 'cisco.svg',
      texts: [
        'The CONSERVE project is working to achieve an integrated platform to improve resilience planning for Smart Cities.',
        'Utilising an instance of Framework.<sup>42</sup> designed to connect people, sensors and mobile workers we will be able to deliver critical datasets to a central location to inform and streamline the decision making process for LRPs (Local Resilience Partnerships) when disaster strikes.',
        'This streamlined communication will reduce costs, improve resource management and help with preventative measures for future disasters.'
      ]
    },
    {
      logo: 'lga.svg',
      texts: [
        'Councils as a Service (CaaS) is an IoT enablement platform for local authorities which cost effectively facilitates improved public engagement, resource management, mobile working and 24/7 responsiveness.',
        'CaaS provides a channel shift to digital, which is proven to improve local authorities services, lead times and has the potential to generate millions in savings.',
        'Framework.<sup>42</sup> is a tried and tested platform for connecting to the IoT and is cited as “best practice for mobile apps” by the LGA (Local Government Association).'
      ]
    },
    {
      logo: 'cisco.svg',
      texts: [
        'Bronze partnered with Cisco, Abellio and Telent to deliver Stations as a Service (StaaS), using an instance of Framework.<sup>42</sup> designed for rail travel.',
        'What we achieved together was a new technical, operational and commercial model for the UK rail industry.',
        'The outcome of our aspect of the project was to achieve significant improvements to rail security and operations.'
      ]
    }
  ],
  featureCards: [
    {
      header: 'Self Build.',
      icon: 'ac-tools-cross',
      text: 'You can be up and running in minutes without any technical knowledge.'
    },
    {
      header: 'Paperless.',
      icon: 'ac-paperclip',
      text: 'Save on the office paper, save on the environment, save on your outgoings. Go paperless.'
    },
    {
      header: 'Mobility.',
      icon: 'ac-lorry',
      text: 'Keep your mobile workers mobile. No need for them to come back to the office.'
    },
    {
      header: 'Faster Invoicing.',
      icon: 'ac-smartphone-mail',
      text: 'Invoices can be sent the second the job is complete, saving time and controlling your cash flow.'
    },
    {
      header: 'Grow Teams.',
      icon: 'ac-users',
      text: 'Quick on-boarding, an easy-to-use app and save money with a ‘bring your own device’ scheme.'
    },
    {
      header: 'Work Offline.',
      icon: 'ac-signal-tower-no',
      text: 'Work in remote locations with no signal? mobile.wkr can sync data when a network becomes available without losing your work.'
    },
    {
      header: 'Consolidate.',
      icon: 'ac-album',
      text: 'All of your data in one place, no need for duplication or manual data entry allowing you to have everything at a glance.'
    },
    {
      header: 'Quantifiable.',
      icon: 'ac-clipboard-chart',
      text: 'Capture KPI data for staff improvement programs and real-time reporting.'
    },
    {
      header: 'Continuity.',
      icon: 'ac-smartphones',
      text: 'If your device is damaged or lost, simply download the apap onto another device and pick up exactly where you left off.'
    }
  ],
  featureVideos: [
    {
      header: 'Forms.',
      text: 'A drag & drop interface and conditional statements allows you to build intelligent forms for your mobile working data collection.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/forms'
    },
    {
      header: 'Area Manager.',
      text: 'Define areas that your mobile workers operate in allowing for more control on who to assign work to.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/areamanager'
    },
    {
      header: 'Smart Assign.',
      text: 'Create a work order with smart filtering allowing you to quickly assign jobs to the right person.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/assign'
    },
    {
      header: 'Cases.',
      text: 'Assets, users and workflows can create cases so you can see what needs doing and what problems have been raised.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/cases'
    },
    {
      header: 'Customer Data.',
      text: 'Add, import or link your customers to have their entire work history and documents to hand.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/customerdata'
    },
    {
      header: 'Dashboard.',
      text: 'Have everything you need at a glance in one location with a dashboard or several.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/dashboard'
    },
    {
      header: 'Flows.',
      text: 'Automate tasks and data by setting up workflows to listen for triggers throughout your entire system.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/flows'
    },
    {
      header: 'Spatial Awareness.',
      text: 'Know where your customers site and mobile workers are allowing you to schedule more efficiently.',
      video:
        'https://storage.googleapis.com/bronze-labs-static/media/product-features/spatialawareness'
    }
  ],
  jobs: [],
  modalActive: false,
  mwkrClients: [
    {
      logo: 'filtermist.svg',
      texts: [
        'Filtermist are a world leading manufacturer of oil mist, smoke and fume extraction.',
        'Using mobile.wkr, they were able to see more customers, grow in size and increase the service side of their business by a remarkable 700%.'
      ]
    },
    {
      logo: 'crt.svg',
      texts: [
        'One of the largest charities in the UK, the Canal River Trust is responsible for the UK’s rivers and waterways.',
        'Using mobile.wkr, CRT were able to increase inspections by 31% with no additional workforce and make a tangible saving of £160K/pa.'
      ]
    },
    {
      logo: 'dakro.svg',
      texts: [
        'Dakro are a leading legionella control service company with a alarge force of mobile engineers.',
        'Using mobile.wkr, they’ve made business efficiencies including 18% in fuel saving, 16% in administration and have carried out over 160,000 customer visits.'
      ]
    },
    {
      logo: 'energ.svg',
      texts: [
        'One of the largest privately owned power companies in Europe, Ener-g have a huge fleet of service engineers and system designers.',
        'Using mobile.wkr, they’ve been able to increase customer service levels, improve cash flow and easily grow and manage their mobile team.'
      ]
    }
  ],
  news: [
    {
      carousel: [
        {
          type: 'vimeo',
          url: '302425252'
        },
        {
          type: 'vimeo',
          url: '302425271'
        }
      ],
      fulltext: '<p>More to follow</p>',
      id: 'f1-connectivity-innovation-prize-2018-winner',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/f1-jamie.jpg',
      subtext:
        'Jamie Gough from Bronze Labs wins the top prize in this years F1 Innovation Awards.',
      title: 'F1<sup>®</sup> Connectivity Innovation Prize 2018 Winner.',
      url: '/news/f1-connectivity-innovation-prize-2018-winner'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '188966397'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip3'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip4'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip5'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip6'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip7'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip8'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/f1cip9'
        }
      ],
      fulltext:
        '<p>Tata Communications, Official Connectivity Provider to Formula 1 and the Official Managed Connectivity Supplier of the Mercedes AMG Petronas Formula One Team, unveiled two teams from Bronze Labs as winners of the 2016 F1<sup>®</sup> Connectivity Innovation Prize.</p><p>The teams were given a chance to compete for the title of grand prize winner during a ceremony at the 2016 Formula 1 United States Grand Prix in Austin, Texas, but were pipped by Datu YogaBrata from Singapore.</p><p>The aim of the F1 Connectivity Innovation Prize is to inspire fans worldwide to harness their technical know-how and passion for F1 racing to drive innovation in the sport. This year’s prize, which involved two challenges set by Formula One Management and the Mercedes AMG Petronas Formula One Team, called for F1 fans to explore ideas about how virtual reality (VR) or augmented reality (AR) could enhance the Formula One experience for fans and help the teams work more effectively together in the run-up to and during each Grand Prix.</p><p>Read more about the Connectivity Innovation Prize at <a href="http://prize.tatacommunications.com" class="link" target="_blank">prize.tatacommunications.com</a></p>',
      id: 'f1-connectivity-innovation-prize-2016-winners',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/f1.jpg',
      subtext:
        'Bronze Labs beat off over 200,000 competitors to provide one of the best innovative augmented & virtual reality solutions to Formula 1.',
      title: 'F1<sup>®</sup> Connectivity Innovation Prize 2016 Winners.',
      url: '/news/f1-connectivity-innovation-prize-2016-winners'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol3'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol4'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol5'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol6'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol7'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol8'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol9'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/mongol10'
        }
      ],
      fulltext: '',
      id: 'the-mongol-rally',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/mongol.jpg',
      subtext:
        'CEO Richard Howells and COO Tom Blockley set out on a 11,000 mile journey from Goodwood racetrack in the United Kingdom to Ulan Ude in Mongolia in a gold wrapped Fiat Panda.',
      title: 'The Mongol Rally.',
      url: '/news/the-mongol-rally'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/india1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/india2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/india3'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/india4'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/india5'
        }
      ],
      fulltext: '',
      id: 'india-tech-summit',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/india-tech-summit.jpg',
      subtext:
        'We were delighted to have been one of 30 companies representing the UK at the UK India Tech Summit in Delhi.',
      title: 'Bronze showcase innovation at India UK Tech Summit.',
      url: '/news/india-tech-summit'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/london-smart-cities1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/london-smart-cities2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/london-smart-cities3'
        }
      ],
      fulltext:
        '<p>The event was hosted at the prestigious Crystal, one of the world’s most sustainable buildings which has the most visited exhibition for urban sustainability on the planet.</p><p>The conference spanned 3 days and had talks from smart city enablers; Ordnance Survey, Nesta and Open Data Institute and we are proud to be recognised as an innovator in the field and deliver a talk on smart city infrastructure for the benefit of society at large. If you would like a copy of Richard’s talk drop us an email and We’ll get it out to you.</p>',
      id: 'london-smart-cities',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/london-smart-cities.jpg',
      subtext:
        'Bronze was recently honoured by an invite from Siemens for our CEO to present a talk at their London Conference on Smart Cities.',
      title: 'The 2016 London Conference on Smart Cities.',
      url: '/news/london-smart-cities'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20161'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20162'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20163'
        }
      ],
      fulltext: '',
      id: 'eiba-2016',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-2016.jpg',
      subtext:
        'Bronze win the Growth and Innovation Award, continuing our innovation since being named winners at the first EIBA ceremony in 2014.',
      title: 'Excellence in Business Awards 2016 Winners.',
      url: '/news/eiba-2016'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/bt-infinity-lab-20161'
        }
      ],
      fulltext: '',
      id: 'bt-infinity-lab-2016',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/bt-infinity-lab-2016.jpg',
      subtext:
        'All the team are proud to have been a finalist in the BT Infinity Lab Connected Cities Awards.',
      title: 'BT Infinity Lab Connected City Awards 2016 Finalists.',
      url: '/news/bt-infinity-lab-2016'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '163704426'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/singapore-future-cities1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/singapore-future-cities2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/singapore-future-cities3'
        }
      ],
      fulltext: '',
      id: 'singapore-future-cities',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/singapore-future-cities.jpg',
      subtext:
        'Richard travelled to Singapore on a mission, organised by Innovate UK and UK Trade and Investment, to pitch Bronze Labs ideas for the future of city living.',
      title: 'Bronze"s Future of Cities.',
      url: '/news/singapore-future-cities'
    },
    {
      carousel: [
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/shropshire-radio'
        }
      ],
      fulltext: '',
      id: 'caas-radio-shropshire',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/shropshire-radio.jpg',
      subtext:
        'Rich has been talking about our Councils as a Service project with Eric Smith and Clare Ashford live on BBC Radio Shropshire.',
      title: 'Councils as a Service on Radio Shropshire.',
      url: '/news/caas-radio-shropshire'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/howells-top-leader1'
        }
      ],
      fulltext:
        '<p>More than two thousand Midlands business leaders applied or were nominated prior to the awards evening which took place at The Belfry, Sutton Coldfield.</p><p>Richard was nominated by the multinational professional services business super titan PricewaterhouseCoopers as the top performing CEO in the Midlands.</p><p>He’ll now go on to fight it out with other UK business leaders at a national event held in London this September!</p><p>Richard said “It is a great honour to have been both independently nominated then receive recognition like this. I obviously feel immensely proud of my team. It is and always has been a huge privilege to lead the growth of Bronze Labs. I have very exciting growth plans for our business within the international area and I look forward to what will certainly be an extremely exciting couple of years ahead as we role out our technologies across the globe.”</p>',
      id: 'howells-top-leader',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/howells-top-leader.jpg',
      subtext:
        'We’re extremely proud to announce CEO Richard Howells is now a finalist for ‘2015 UK Emerging Entrepreneur of the Year Award’.',
      title: 'Howells Recognised as a Top UK Business Leader.',
      url: '/news/howells-top-leader'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '113699314'
        },
        {
          type: 'vimeo',
          url: '113008533'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/vr-training-environment1'
        }
      ],
      fulltext:
        '<p>Thom Kennedy from Shropshire Star has written an article about the technology</p><p>"Utterly motionless, with no wind or gravity pulling at them, they sit weightlessly, interrupted only when a robotic arm swings through the pitch black and swipes childishly at the rudimentary shapes. Looking down, it appears that these limbs, fibreglass perhaps, with their fingers and palms connected by white hinges, appear to be extensions of my the user’s own form."</p><p>"This is how life appears when you are dropped into The Rift. More precisely, this is Oculus Rift, the future of gaming, in which users wear a full headset to completely immerse them in a virtual world."</p><p>"The headset, which has to be pulled taut over the bonce, belongs to Telford-based software developers Bronze Labs."</p><p>"The cutting-edge business, which is simultaneously developing programs for Google Glass, has combined the set with movement sensors from Leap Motion so when you look through the screens inside the set, you can interact with the world that you see without using a handset."</p><p>"Instead, by waving a hand at objects in your eyeline, you can move things that you can find in “The Rift” – in this program’s case, those hundreds of colourful floating cubes."</p><p>"But the Priorslee company isn’t joining the ranks of developers using this technology for gaming, and is instead looking at its real world applications such as training."</p><p>"To that end, when you are plonked into the cockpit of an F10 fighter jet, you will by looking around be able to fire rockets, see the real workings of a plane in flight above a hyper-realistic ocean."</p><p>Company director Rich Howells said "We have taken one of the most advanced virtual reality technologies out there and one of the most advanced hand and motion detection technologies and combined them into one environment."</p><p>"We take on all this new technology and explore it, and in doing so we have come up with an extremely powerful way to cut the costs of training for businesses."</p><p>"That has major implications for training on aircraft and vehicles."</p><p>"We have spoken to people who have sat in front of computers and looked at vehicles they are supposed to be servicing or changing parts on, and when they get to the actual vehicle they have struggled to apply their teaching."</p><p>"With Oculus Rift, they can do all that training in The Rift. What you currently get on multi-million pound simulators, we can achieve with our technology."</p>',
      id: 'vr-training-environment',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/vr-training-environment.jpg',
      subtext:
        'We have taken one of the most advanced virtual reality and motion detection technologies to create an immersive training environment.',
      title: 'Bronze Create Immersive Training Environment.',
      url: '/news/vr-training-environment'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/prince-charles-middleport1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/prince-charles-middleport2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/prince-charles-middleport3'
        }
      ],
      fulltext:
        '<p>Middleport Pottery in Stoke-on-Trent was founded in 1888 to produce Burleigh pottery and built up a worldwide reputation, employing 500 people by 1939. By 2011, however, the workforce was bare, orders were in short demand and it looked destined for closure and demolition. The Prince’s Regeneration Trust stepped in, buying the entire site as a working factory and creating a heritage tourist attraction. Bronze Software Labs were approached to take on the task of bringing this heritage site into the 21st Century with a modern way to engage it’s audience through technology.</p><p>On Tuesday 24th June 2014, Prince Charles came to visit the project to see how it was all coming along. Ros Kerslake, Chief Executive of The Prince’s Regeneration Trust said: ‘Middleport Pottery is a living and breathing part of British industrial history because Burleigh pottery is still made here using traditional techniques and skills. We’re delighted to be opening it up as a major visitor destination, so it can be enjoyed and appreciated for generations to come. We are thrilled that His Royal Highness, our President, is here today to officially open the Pottery and to share this very special moment with us and with Stoke-on-Trent.</p><p>The project is well under way, and as part of this we produced an Augmented Reality experience at the start of what will become a Beacons Tour giving visitors information to a smart device as they walk around the working factory.</p>',
      id: 'prince-charles-middleport',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/prince-charles-middleport.jpg',
      subtext:
        'We’re extremely proud to have our print, augmented reality and BLE work for Middleport Pottery examined by Prince Charles.',
      title: 'Prince Charles visits us at Middleport Pottery.',
      url: '/news/prince-charles-middleport'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/rafbf-award1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/rafbf-award2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/rafbf-award3'
        }
      ],
      fulltext:
        '<p>The innovative team @BronzeLabs has created the world’s first 3D Augmented Reality App for a charity, opening up a new potential audience for the RAFBF. The AR App enables viewers to experience the iconic British aircraft and raise funds for the Royal Air Force Benevolent Fund at the same time. The awards ceremony was held at the Royal Institute of British Architects in London, 1st May 2014.</p><p>The award was presented by Mr Bernard Edwards, Chairman of MooD and an RAF Benevolent Fund Ambassador. This is the second year that the RAF Benevolent Fund has recognised the stand-out contributions made by a few of the dedicated individuals, stations, and corporate partners who support the charity each year.</p><p>In advance of the 75th anniversary of the Battle of Britain in 2015, we launched the Official RAFBF Spitfire Augmented Reality App. After downloading the App, mobile phone users can explore and interact with the high detail 3D model of a Spitfire, rotate the plane 360 degrees, start the engine, and fire machine guns. Bronze HQ in Telford is based just a few miles down the road from the West Midlands RAF base in Cosford, Shropshire. The team spent hours studying the Spitfire’s iconic lines and design while creating this stunning Augmented Reality App. Built to a very tight timescale to meet the Battle of Britain anniversary in Sept 2014, the App was conceived, designed and built in less than 30 days.</p><p>The App is available to download world wide and uses major currencies from the UK, US, Europe, Australia, New Zealand, Japan to name just a few. It’s been designed and built from the ground up, for iPhones and is sold for £1.49 from iTunes with profits going to the RAF Benevolent Fund.</p>',
      id: 'rafbf-award',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/rafbf-award.jpg',
      subtext:
        'Bronze has created the world’s first 3D Augmented Reality App for a charity, opening up a new potential audience for the RAFBF.',
      title: 'Bronze Wins Top Innovation Award for RAFBF.',
      url: '/news/rafbf-award'
    },
    {
      carousel: [
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20140'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20141'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20142'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20143'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20144'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20145'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20146'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20147'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20148'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-20149'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201410'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201411'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201412'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201413'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201414'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-201415'
        }
      ],
      fulltext:
        '<p>The Shropshire Star Excellence in Business Awards black-tie event took place on Thursday, April 3, 2014 at RAF Cosford Museum where Bronze was announced as winners for Best Young Business of the Year. To win the award we had to demonstrate qualities such as dynamic leadership, innovative product/service development and a robust marketing strategy. We needed to provide evidence of ambition and business acumen, having achieved a tangible level of success, and be able to demonstrate how the commitment of our team is supporting the drive of the business towards further growth. We were described as a strong all-rounder, already a leader in its own chosen area of expertise, with a clear and deliverable vision for the future. We are extremely proud to have been voted as the Best Young Business of the Year and strive to pick up many more awards in the future.</p>',
      id: 'eiba-2014',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/news/eiba-2014.jpg',
      subtext:
        'Bronze was announced as winners for Best Young Business of the Year at the Excellence in Business Awards 2014.',
      title: 'Excellence in Business Awards 2014 Winners.',
      url: '/news/eiba-2014'
    }
  ],
  solutions: [
    {
      carousel: [
        {
          type: 'vimeo',
          url: '113699314'
        }
      ],
      fulltext:
        '<p>Oculus Rift can also be paired with Leap Motion and force feedback controllers, all together making a completely immersive experience and cutting down the costs of fully built simulators. This technology can also be used on any training environment such as cars, tanks, parts etc. In this quick demo, we have an F10 aircraft which shows a few instrument panels, fires rockets and ejector seat! Each eye is separated very much as you would see in a 3D movie, so that you see each image as one inside the Rift headset.</p>',
      id: 'oculus-rift-vr',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/oculus_simulator.jpg',
      subtext:
        'A demo using Oculus Rift to demonstrate how the technology can be used as an alternative to aircraft simulators, aiding pilots in understanding how the cockpit in their aircraft works.',
      tags: ['tag-research-development', 'tag-augmented-virtual-reality'],
      title: 'Oculus Rift VR Simulator For Aircraft Piloting',
      url: '/solutions/oculus-rift-vr'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '99918582'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/markerless_tracking'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/defense_bg'
        }
      ],
      fulltext:
        '<p>We tested this on a 1965 Leopard battle tank using open source CAD data. The technology can be used to effectively create a 3D representation of the object, this can then be used to show and instruct complex and routine maintenance procedures like how to disassemble a part, or show a breakdown of information and service data on subsystems. The technology enables us to track the object from any angle on any scale of object. The possibilities of how to use this are endless and vital in aiding and tutoring people in real time, right in front of them.</p>',
      id: 'tank-augmented-reality',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/markerless_tracking.jpg',
      subtext:
        'We went to RAF Cosford to test out a technology we have been working on that uses markerless tracking AR technology using natural feature tracking to track real objects in real time.',
      tags: [
        'tag-heritage',
        'tag-military',
        'tag-research-development',
        'tag-augmented-virtual-reality'
      ],
      title: 'Markerless Tracking Augmented Reality',
      url: '/solutions/tank-augmented-reality'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '110982617'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/sehome_bg'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/se_demo'
        }
      ],
      fulltext:
        '<p>Walk around and up to virtual switches and sockets in the comfort of your own home to see which design and finish best compliments your room decor.With a wide choice of wiring accessories ranging from traditional British Classics, ultra minimalist chic or creative ‘design your own’ ranges to suit any room – updating your home has never been easier or more fun!Our innovative Visualiser also includes a ‘Be Inspired’ feature where you can easily create and print your own designs for Schneider’s Ultimate Transparent wiring accessories. Showcase your favourite images with anything from family photos, holiday snaps or pets and hobbies as the finishing touch to any room. Or alternatively, match to your walls for the truly invisible touch!</p><p>Choose a wiring accessory to visualise from the selection menu and align your device to a wall surface of your choice or over an existing wiring accessory making sure that there is plenty of detail in view and that the camera is steady. Once the app has detected your surface, select the green tick to visualise the 3D wiring accessory!It can sometimes be hard when searching for the correct fitting in your home when out and about in shops. With the visualiser, you can see the switch in situ at home before you commit to buying.</p>',
      id: 'schneider-home-visualiser',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/sehome_bg.jpg',
      subtext:
        'An innovative and unique experience for customers delivered through Augmented Reality.',
      tags: ['tag-augmented-virtual-reality', 'tag-retail'],
      title: 'Schneider Electric’s Home Touch Visualiser.',
      url: '/solutions/schneider-home-visualiser'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '101905092'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/proto_bg'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/proto_detail'
        }
      ],
      fulltext:
        '<p>Proto Labs is a rapid manufacturer of prototype and low-volume production parts. To better understand the often complicated process of injection molding, we’ve created Design3 – an augmented reality (AR) app that allows users to digitally explore multiple facets of thermoplastic injection molding through a design cube.</p><p>Upon opening Design3, simply point your mobile device at any Proto Labs logo for the three-dimensional cube to appear. With the swipe of a finger, you can rotate the cube 360 degrees to reveal the different elements that product developers encounter during part design. Tap on each feature to learn about thick and thin bosses, knit lines, ribs, surface finishes, undercuts and other design considerations.Our virtual design cube is based on Proto Labs’ popular Design Cube aid, the physical counterpart to Design3. Users are able to order a free Design Cube directly within the app.</p>',
      id: 'protolabs-design3-app',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/proto_bg.jpg',
      subtext:
        'Design3 is an augmented reality (AR) app that allows users to digitally explore multiple facets of thermoplastic injection molding through a design cube.',
      tags: ['tag-augmented-virtual-reality'],
      title: 'Protolabs Design3 App',
      url: '/solutions/protolabs-design3-app'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '99336655'
        },
        {
          type: 'vimeo',
          url: '100708944'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/mp_detail'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/mpglass'
        }
      ],
      fulltext:
        '<p>The tour uses iBeacons to guide and instruct visitors of information about the location they are in. Visitors start the tour in the lodge where they will find this Pottery Model, a complete scaled replica of the Pottery they will further tour. Here they have the opportunity to find out about the Pottery through the use of their smartdevice and Google Glass.</p><p>Middleport Pottery, home of Burleigh, is an exciting visitor destination in the heart of Burslem, the Mother Town of the potteries. World-famous Burleigh pottery has been created here using traditional methods since 1889.</p><p>With Natural Feature Tracking (NFT), we can add augmented reality to the environment without the traditional use of an image target to generate the content. Instead NFT looks constantly for objects that it has been programmed to recognise, generates the content once found, and keeps the content in vision by scanning the area to calculate movement away from the object.</p><p>For a visitor to see the Middleport Pottery Tour in front of their eyes on a scaled replica is a much more interactive way to guide them around than the traditional method of a foldout printed map. It’s vital for the Middleport Pottery to attract crowds of all ages, so the use of technology brings in the audience and makes Middleport Pottery a ‘not your average place to visit’. It stands out from other day activities that are on offer and yet maintains the traditional heritage that it’s built on. Later in the year, we shall be adding in Beacons to the Pottery, to be used so that visitors can walk around the real pottery and get information to their smartdevice as they walk around showing different information depending on where in they pottery the are.</p>',
      id: 'middleport-pottery',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/mp_detail.jpg',
      subtext:
        'An Augmented Reality tour for Middleport Pottery which has been funded by the Princes Regeneration Trust, and the Heritage Lottery fund for all to experience and enjoy.',
      tags: ['tag-augmented-virtual-reality', 'tag-heritage'],
      title: 'A Model of a Model Pottery',
      url: '/solutions/middleport-pottery'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '94878421'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/treasuretrove'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/pearsontt_para1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/pearsontt_para2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/pearsontt_para3'
        }
      ],
      fulltext:
        '<p>Pearson is an education publishing and assessment service to schools and corporations, as well as directly to students. Pearson owns leading educational media brands and also owns Penguin Books and the Financial Times. Though Pearson generates approximately 60% of its sales in North America, they operate in more than 70 countries. Pearson International is headquartered in London with offices across Europe, Asia and South America.</p><p>Bronze Labs were brought in to help with data capture at the exhibition and events that Pearson showcase at. With the use of a game and a prize to win, users were quick to go to the Pearson stand and stay there whilst sharing important information to Pearson.</p><h3>Not Just a Game, but a Data Generator</h3><p>If you have ever visited an exhibition or event you will often see a bunch of staff hovering around trying to get you to fill out forms and surveys… and you would mostly try at all cost to get away from them. This method prevents businesses from gaining valuable information about their customers. With the use of a game, crowds would gather and stay around that area… especially when a prize for the top score is in the offering.</p><h3>A Quick Lead Generation Tool</h3><p>It’s simple, our customer comes along, they enter their details and complete a short form for our customer data records, they play the game for 60 seconds and the next customer comes along. The process is short and generates a great number of customer information.</p><h3>Saving Time &amp; Resources</h3><p>With the game displayed on the exhibition stand there is no need for staff to linger around trying to get customer details. The customer has to input the details you require on the interface before they can play the game. They have 1 minute to play and then the next customers has their turn. This way, you get what you want in the shortest space of time without any effort. This free’s your staff up to talk to those who really do want to know more information.</p>',
      id: 'pearson-treasure-trove',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/treasuretrove.jpg',
      subtext:
        'Pearson is an education publishing and assessment service to schools and corporations, as well as directly to students.',
      tags: ['tag-educational'],
      title: 'Pearson Treasure Trove Event Game',
      url: '/solutions/pearson-treasure-trove'
    },
    {
      carousel: [
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/eyecastle'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/eye_para1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/eye_para2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/eye_para3'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/eye_para4'
        }
      ],
      fulltext:
        '<p>Eye Castle is a motte and bailey medieval castle with a prominent Victorian addition in the town of Eye, Suffolk. Built shortly after the Norman conquest of England in 1066. Bronze Labs were required to bring the story of Eye Castle to life through the appropriate use of technology. Visitors have access to an immersive experience, whilst having fun, bridging the gap between paper, digital and the real world with an augmented world.</p><p>Our understanding of the various trail and way marker technologies, gives us the ability to tailor our approach to develop a Smartphone App that would provide a personal insight into the stories of the village of Eye, its people and its castle over a millennium.</p><h3>More than 15 locations around the Eye Castle</h3><p>The app was built with the help of the districts schools as their drawings of castle life contributed greatly to the added fun elements of the app. With a range of skilled illustrators and artists, cartoonists, animators, copywriters, archaeologists, and researchers used to develop the app, this truly becomes a historic and accurately told story of Eye Castle and it’s town and using GPS marked routes, the user can live through the ages of Eye and take a tour around the town informing them of the facts surrounding that area.</p><h3>Fun &amp; Educational for All</h3><p>There is a motte, an inner bailey and an outer bailey and Eye castle was once an important building in its day. The street plan of Eye is today still based on the castle outline and the app not only shows this in accurate detail but gives our visitors a fun, educational and engaging opportunity to experience life of the Eye in all of it’s former glory.</p><h3>Augmented Reality Trail</h3><p>Not only does the app provide a historically accurate background and tour of Eye Castle and its town, but users can also have a go at unlocking Augmented Reality models of elements from the age of Eye such as market life, and the Eye Castle itself. Users have 5 mini challenges to complete from ‘Flight of the Falcon’ (a medieval flappy bird) to Eye Spy. Each game unlocks an Augmented Reality image target that is displayed on wooden benches around the Eye Castle. The user then has to scan these benches to see the interactive content that will eventually unlock an Augmented Reality Eye Castle model for you to find around the area.</p>',
      id: 'eye-castle',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/eyecastle.jpg',
      subtext:
        'Bringing the story of Eye Castle to life through an immersive experience, bridging the gap between paper, digital and the real world with an augmented world.',
      tags: ['tag-augmented-virtual-reality', 'tag-heritage'],
      title: 'Eye Castle - Heritage Trail',
      url: '/solutions/eye-castle'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '102340691'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/twc_bgmain'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/yogi_bg'
        }
      ],
      fulltext:
        '<p>No hanging on the telephone, no waiting for offices to open, simply follow the instructions and send it through and let us do the rest. You can even take a photo of the issue and use your phone’s GPS to store the location so we can find it easily.</p><p>And you don’t have to use your mobile data connection there and then – simply save it in your phone until Wifi is available, so it won’t cost you a penny.</p><h3>Looking Ahead with Telford &amp; Wrekin Council</h3><p>For at least a decade, mobile technology has been evolving at a pace that councils are hard-pressed to keep up with and because consumer preferences are moving just as quickly, councils have to adapt and become more agile.</p><p>Telford & Wrekin Council has been working with our team to streamline and automate internal operations, making its brick and mortar service more efficient, accessible and responsive to changes in demand. Telford & Wrekin Council is making investments in building its digital presence, and Bronze Labs has now delivered the first results in that part of the partnership — a mobile application to enable members of the public to register and create live tasks for the attention of council services.</p><p>Telford & Wrekin Council, one of the fastest growing local authority boroughs in the UK, has partnered with Bronze Software Labs Ltd to help in a major strategic push for greater council agility. Council agility is the ability to take advantage of channel shifting, greater operational efficiency and improved public engagement at a speed that keeps up with fast-changing consumer habits and technology whilst being in-line with the challenging current government savings targets.</p><p>Bronze Labs built the cross-mobile application for iPhone, Android and Windows Mobile devices — along with a set of reusable back-end enterprise system services for content management, customer accounts and real-time seamless integration with the councils Microsoft Dynamics CRM data management systems.</p><p>Bronze Labs delivered everything, on time, in just fifteen weeks; enabling Telford & Wrekin to keep a strategic commitment to launch a new digital channel in time for the winter period. With the new service layer and the internal knowledge gained from the initial deployment, the authority can launch additional data driven services with confidence and speed.</p>',
      id: 'everyday-telford',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/twc_bgmain.jpg',
      subtext:
        'Everyday Telford aims to make it quick and easy to report the things that are important to you, whenever and wherever you are.',
      tags: ['tag-government', 'tag-mobile-working', 'tag-iot'],
      title: 'The Everyday Telford Reporting App',
      url: '/solutions/everyday-telford'
    },
    {
      carousel: [
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/crtlima_bg'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/limapara1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/limapara2'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/limapara3'
        }
      ],
      fulltext:
        '<p>The inspectors are required to monitor current asset condition against previous condition. This is achieved through reviewing SAP Notifications, Comments and Asset Grades displayed within the app using a schematic representation of the navigation and a number of GUI forms. Where required new notifications, asset grades and comments are edited or created in situ either at a GPS location or through the systems data entries. These feed back into corporate systems principally SAP and GIS and are used to monitor condition and schedule works as required.</p><h3>Live GPS Data as you Inspect the Waterways</h3><p>The app is designed to help inspectors enter data on the condition of the canal, as well as surrounding structures. Canals are broken down into a series of inspections which are typically around 1km in length. Each walk is then broken down further into 25m sections (known as markers).</p><p>As they are walking along the canal, the app uses GPS to track the user’s location and automatically scrolls the inspection to the nearest marker. They can enter details about the marker, as well as nearby “assets” (e.g. bridges, locks) and raise “notifications” if there is a problem which needs to be addressed.</p><h3>Making the Waterways Manageable</h3><p>The process and user interaction is simple, intuitive and efficient. The application back office system synchronisation with SAP and GIS is in real time meaning that it minimises resource time allowing for us to work much faster in inspections and resulting actions.</p><h3>Live Version Control</h3><p>Each audit has a trail so that an administrator can see differences on the canal over time. All the information regarding the particular audit is collected automatically such as when and where the entry was submitted. This allows for tighter control on any errors that may arise, for instance, if the walkway needs attention on one audit but the next audit is carried out in snowy conditions, the inspector may have missed any detail due to those conditions – with version control, this error would not go unnoticed.</p>',
      id: 'crt-length-inspection',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/crtlima_bg.jpg',
      subtext:
        'A mobile working solution for live complex GPS data along the canals of Great Britain.',
      tags: ['tag-iot', 'tag-mobile-working'],
      title: 'Canal & River Trust Length Inspection App',
      url: '/solutions/crt-length-inspection'
    },
    {
      carousel: [
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/bingley_bg'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/crt_detail'
        }
      ],
      fulltext:
        '<p>One of the Seven Wonders of the Waterways, there is plenty for the whole family to see and do at Bingley Five Rise Locks. Try a whole range of exciting new ways for the family to explore the Leeds & Liverpool Canal between Bingley and Saltaire. You can walk or cycle down the towpath and come back by train or bus. Bronze have produced a range of things to help you plan your visit, enjoy your day out and encourage you to come back again.</p><h3>Built to the Highest Standard</h3><p>Bronze’s work has been second to none and the results are of the highest standard. Their grasp and understanding of all the recent technological advancements has enabled us to develop a scheme that is at the forefront of modern interpretative methods and I am yet to see anything like this at any other heritage attractions.</p><p>- Stephen Higham, Regeneration Manager, CRT</p><h3>Heritage Awareness</h3><p>We’ve worked with the Canal & River Trust on a Heritage Awareness Project. This includes the creation of interpretive material for bespoke panels, bespoke cast iron waymarkers, leaflets, QR code / NFC trail, smartphone App, educational resources, animation and GPS geocaching trails for families and more experienced users.The application "includes": Low level aerial video commissioned by ourselves, audio recording and oral history from community consultation workshops, QR code scanner, NFC compatibility, GPS based maps with filters and map overlays, full screen slideshow and captions, and a digital compass all wrapped up in a bespoke design.</p><p>One of the ‘Seven Wonders of the Waterways’ Bingley Five Rise Locks are an awesome feat of engineering raising the canal 18 metres (60 feet). It is supported by a series of QR code plaques featuring NFC tech along the stretch of the canal to encourage visitors to walk from the very popular Saltaire WHS to the Bingley Five Rise Locks.</p>',
      id: 'crt-bingley-five-rise',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/bingley_bg.jpg',
      subtext:
        'Take a tour from the Bingley Five Rise Locks to the very popular Saltaire WHS and more with the Bingley to Saltaire Trail App for iPhone.',
      tags: ['tag-heritage', 'tag-education'],
      title: 'Canal & River Trust Bingley Five Rise',
      url: '/solutions/crt-length-inspection'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '90428819'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/maa_bgmain'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/maa_home'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/air_para1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/air_para3'
        }
      ],
      fulltext:
        '<p>Midlands Air Ambulance serves the largest air ambulance region in the UK. This includes the communities of Gloucestershire, Herefordshire, Shropshire, Staffordshire, West Midlands and Worcestershire; representing a population of more than 6 million. Each year it costs in excess of £6.5 million just to keep the three charity helicopters operational. The charity receives no funding from the government or National Lottery so relies entirely on the support and generosity of local people and businesses.Now it’s even easier to learn about the charity and make a donation through Bronze Labs ‘A.I.R Ambulance’ app available on iOS and Android.</p><h3>Barclay"s Pingit</h3><p>Most AR applications require an ‘image target’ to be in view at all times to render the 3D model, but with our technology, that is a thing of the past as we feature ‘extended tracking’. Once the model has been rendered the image target can be taken away and the model can still be viewed in its place.We all agreed that the best way to make the connection between the application and the charity was to use money as an ‘image target’. What could be better than holding a potential donation whilst thinking about a hugely worthwhile charity. The app allows people to donate via text and also includes Barclay’s Pingit to give people more options on donating.</p><h3>Raising Awareness</h3><p>We are delighted to have worked with Bronze Labs and are astounded by what they have accomplished with the new App. We believe it will raise further awareness online of the life saving work of our air ambulance.A.I.R. Ambulance not only gives users on both Apple and Android devices the ability to learn more about our vital life saving service, but they can also see and hear our helicopter take flight, thanks to the amazing augmented reality technology. The launch of our App is an extremely significant and important milestone as we strive to raise our awareness with a younger and more tech-savvy audience and we can’t praise Bronze Labs highly enough.</p><p>-Jason Levy, Fundraising Manager at MAA</p><h3>Supporting MAAC</h3><p>Most people don’t realise the costs of keeping the Midlands Air Ambulance in operation and the app is used to demonstrate those costs whilst enabling the user the opportunity to show their support through donation.As MAAC remains one of the region’s most treasured charities, they are extremely fortunate to have a great number of volunteers, fundraisers and supporters to assist them to raise the £6.5 million needed each year to remain operational and MAAC would not be the great success it is today without their hard work and dedication.Our entire team are proud to support the Midlands Air Ambulance through the development of our super cool augmented reality app available on iOS and Android.</p>',
      id: 'midlands-air-ambulance',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/maa_bgmain.jpg',
      subtext:
        'Our entire team are proud to support the MAA through the development of our super cool Augmented Reality app featuring an Appstore first – donations via Barclay’s Pingit!',
      tags: ['tag-augmented-virtual-reality', 'tag-charity'],
      title: 'Midlands Air Ambulance AR App',
      url: '/solutions/midlands-air-ambulance'
    },
    {
      carousel: [
        {
          type: 'vimeo',
          url: '89836558'
        },
        {
          type: 'vimeo',
          url: '74932901'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/rafbf_bgmain'
        },
        {
          type: 'video',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/rafbf_home'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/rafbf_para1'
        },
        {
          type: 'image',
          url: 'https://storage.googleapis.com/bronze-labs-static/media/solutions/rafbf_para3'
        }
      ],
      fulltext:
        '<p>Our journey with the RAF-BF started just 30 days before the target launch date to build an application which could mark the anniversary of the Battle of Britain, September 2013. We were obviously very excited to be working with such a prestigious charity to showcase our company’s capabilities and pull out all the stops to deliver something very special within the confines of our specification.</p><h3>Motion and Money targeting was Key</h3><p>Our specialist app development team designed several concepts around the iconic Supermarine Spitfire MK2 including accelerometer-driven and gesture-based navigations. We felt that motion, and specifically the visual aspect of the Spitfire propeller had to play a significant part in our application.Several 3am finishes later and the design and concept work was finished. We all agreed the best way to make the connection between the application and a charity was to involve Augmented Reality ‘image targeting’ linked directly to money. What could be better than holding a potential donation whilst thinking about a hugely worthwhile charity.</p><h3>A Mention by Stephen Fry</h3><p>Got an iPhone 5? Download the new Spitfire AR app from @BronzeLabs & @RAFBF http://delivr.com/29fw6_nfc & take the #SpitfireChallenge</p><p>Stephen Fry (@stephenfry) September 20, 2013</p><h3>Proud to Support</h3><p>Most people don’t appreciate the RAF-BF charity is now 94 years old. As with most charities which span generations, they’re interested in innovative ways to engage with and raise the profile of their important work. In building this app we believe we’ve succeeded in harnessing the very latest mobile technologies to spark the interest in audiences across the globe. We’d like to think of our technologies as a type of 21st century ‘storytelling’. It’s extremely important for people to understand we are proud of the British heritage and we believe our technologies are the key to keeping the history in the hearts and minds of the youngest generations. Our entire team are proud to support the RAF-BF through the development of what we think could be one of the most advanced iOS applications in the AppStore.</p>',
      id: 'rafbf',
      image:
        'https://storage.googleapis.com/bronze-labs-static/media/solutions/rafbf_bgmain.jpg',
      subtext:
        'Our entire team are proud to support the RAF-BF through the development of what we think could be one of the most advanced iOS applications in the AppStore.',
      tags: ['tag-augmented-virtual-reality', 'tag-charity'],
      title: 'The Official RAFBF AR App',
      url: '/solutions/rafbf'
    }
  ],
  tags: [
    {
      classname: 'tag-research-development',
      name: 'Research & Development'
    },
    {
      classname: 'tag-mobile-working',
      name: 'Mobile Working'
    },
    {
      classname: 'tag-iot',
      name: 'IoT'
    },
    {
      classname: 'tag-augmented-virtual-reality',
      name: 'Augmented & Virtual Reality'
    },
    {
      classname: 'tag-military',
      name: 'Military'
    },
    {
      classname: 'tag-government',
      name: 'Government'
    },
    {
      classname: 'tag-retail',
      name: 'Retail'
    },
    {
      classname: 'tag-charity',
      name: 'Charity'
    },
    {
      classname: 'tag-heritage',
      name: 'Heritage'
    },
    {
      classname: 'tag-educational',
      name: 'Educational'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/site-content.js